import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../App";
import { fetchDataFromApi } from "../../utils/api";
import ProductItem from "../../Components/ProductItem";
import NoProductsFound from "../../Components/NoProductsFound";

const NewProducts = () => {
  const [productsData, setProductsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const context = useContext(MyContext);

  useEffect(() => {
    fetchDataFromApi(`/api/products?page=1&perPage=8`)
      .then((res) => {
        setProductsData(Array.isArray(res.data) ? res.data : []); // Use res.data for paginated API
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching products data:", error);
        setProductsData([]); // Fallback to an empty array
        setIsLoading(false);
      });
  }, []);

  const SkeletonProductItem = () => (
    <div
      className="productItem bg-gray-200 rounded-lg overflow-hidden relative"
      style={{ width: "250px", height: "331px", margin: "0 10px" }}
    >
      <div className="w-full h-3/4 bg-gray-300 animate-pulse"></div>
      <div className="p-2.5 h-1/4">
        <div className="w-3/4 h-5 bg-gray-300 mb-2.5 animate-pulse"></div>
        <div className="w-1/2 h-5 bg-gray-300 animate-pulse"></div>
      </div>
      <div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-75 animate-shimmer"
        style={{
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
        }}
      ></div>
    </div>
  );

  const styles = `
  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  `;

  const styleTag = document.createElement("style");
  styleTag.innerHTML = styles;
  document.head.appendChild(styleTag);

  return (
    <>
      <div className="d-flex align-items-center mt-2">
        <div className="info w-75">
          <h3 className="mb-0 hd">NEW PRODUCTS</h3>
          <p className="text-light text-sml mb-0">
            New products with updated stocks.
          </p>
        </div>
      </div>

      {/* Show skeleton while loading; when not loading and empty, show message */}
      <div className="product_row productRow2 w-100 mt-4 d-flex productScroller ml-0 mr-0">
        {isLoading ? (
          [...Array(8)].map((_, index) => <SkeletonProductItem key={index} />)
        ) : productsData.length > 0 ? (
          productsData
            .slice(0)
            .map((item, index) => <ProductItem key={index} item={item} />)
        ) : (
          <NoProductsFound />
        )}
      </div>
    </>
  );
};

export default NewProducts;
